import { Breadcrumbs, Link } from "@mui/material";
import { ReactNode, useContext, useEffect, useState } from "react";
import { ApplicationLocationContext } from "../../utils/ApplicationState";
import { theme } from "../../Common/UI/styles/theme";
import { NavigateNext } from "@mui/icons-material";

export const BreadcrumbsBar = () => {
  const [steps, setSteps] = useState<ReactNode[]>([]);
  const { state } = useContext(ApplicationLocationContext);
  
  useEffect(() => {
    let newSteps: ReactNode[] = [];

    newSteps.push(
      <Link key={"home"} href="/" color={"#000000"} underline="none">
        Spirit Night
      </Link>
    );

    for (let i = 0; i < state.path.length; i++) {
      let currentColor = i !== state.path.length - 1 ? "#000000" : theme.palette.primary.main;

      const currentStep = state.path[i];
      newSteps.push(
        <Link key={currentStep} href="#" color={currentColor} underline="none">
          {currentStep}
        </Link>
      );
    }
    setSteps(newSteps);
  }, [state.path]);

  return (
    <Breadcrumbs
      separator={<NavigateNext sx={{ fontSize: "16px" }} />}
      aria-label="breadcrumb"
      sx={{
        fontSize: "18px",
        fontWeight: 500,
        flex: 1,
        padding: "24px"
      }}
    >
      {steps}
    </Breadcrumbs>
  )
}
